<!-- v1.5 - in use -->

<template>

  <div class="loading loading--pdp-dd" v-if="loading"> 
    <!-- <loadingAnimation /> -->
    <div class="pdp-dd-loading-header"><span></span></div>
    <div class="pdp-dd-loading-body"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>
  </div>
  <div v-else id="pdpDdabc">
    <div class="ctpx-pdp-dd-intro allpa-special" v-if="getAllpaData()">
      <div class="bg allpa-special">
        <div class="allpa-highlight">
          <div class="row" v-if="isMobile">
            <div class="col">
              <h1 class="display-1">{{getAllpaData().title}}</h1>
              <h4 class="price display-4">
                <span>{{
                  filterPrice(ddProduct.price)
                }}</span>
              </h4>
              <p class="lead">{{getAllpaData().intro}}</p>
            </div><!-- .col -->
          </div><!-- .row --> 
          <img :src="getAllpaData().imgHero" :alt="getAllpaData().title" class="img-fluid">
        </div>
        <div class="allpa-details">
          <div class="row" v-if="!isMobile">
            <div class="col">
              <h1 class="display-1">{{getAllpaData().title}}</h1>
              <h4 class="price display-4">
                <span>{{
                  filterPrice(ddProduct.price)
                }}</span>
              </h4>
              <p class="lead">{{getAllpaData().intro}}</p>
            </div><!-- .col -->
          </div><!-- .row --> 
          <div class="row">
            <div class="col-4">
              <img :src="getAllpaData().imgOne" class="img-responsive" :alt="getAllpaData().featureOne">
              <p>{{ getAllpaData().featureOne }}</p>
            </div><!-- .col -->
            <div class="col-4">
              <img :src="getAllpaData().imgTwo" class="img-responsive" :alt="getAllpaData().featureTwo">
              <p>{{ getAllpaData().featureTwo }}</p>
            </div><!-- .col -->
            <div class="col-4">
              <img :src="getAllpaData().imgThree" class="img-responsive" :alt="getAllpaData().featureThree">
              <p>{{ getAllpaData().featureThree }}</p>
            </div><!-- .col -->
          </div><!-- .row --> 
        </div>
      </div>
    </div>
    <div class="ctpx-pdp-dd-intro" v-else>
      <div
        v-if="!isMobile"
        class="bg"
        :style="{
          backgroundImage: 'url(' + ddProduct.headerImageDesktop.replace('upload', 'upload/w_1400/f_auto,q_auto') + ')',
        }"
      >
        <div class="row">
          <div class="col text-center">
            <!-- ==================== MINI YOTPO STARS ==================== -->
            <div
              @click="scrollToReviews()"
              class="reviews"
              v-if="numReviews > 0"
            >
              <ReviewStars
                :numStars="avgReview"
                :numReviews="numReviews"
                baseColor="#bdbdbd"
                fillColor="#ffffff"
              />
            </div>
            <!-- .reviews -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col text-center">
            <h1>{{ ddProduct.title }}</h1>
            <h4 class="price display-4">
              <span>{{
                filterPrice(ddProduct.price)
              }}</span>
            </h4>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-10 text-center">
            <p class="lead" v-html="ddProduct.whyYoullLoveIt.a"></p>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!--.bg-->
      <div v-else
        class="bg"
        :style="{ backgroundImage: 'url(' + ddProduct.headerImageMobile + ')' }"
      >
        <div class="row">
          <div class="col text-center">
            <!-- ==================== MINI YOTPO STARS ==================== -->
            <div
              @click="scrollToReviews()"
              class="reviews"
              v-if="numReviews > 0"
            >
              <ReviewStars
                :numStars="avgReview"
                :numReviews="numReviews"
                baseColor="#bdbdbd"
                fillColor="#ffffff"
              />
            </div>
            <!-- .reviews -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col text-center">
            <h1>{{ ddProduct.title }}</h1>
            <h4 class="price display-4">
                <span>{{
                  filterPrice(ddProduct.price)
                }}</span>
              </h4>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
            <p class="lead" v-html="ddProduct.whyYoullLoveIt.a"></p>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!--.bg-->
    </div>
    <!-- ctpx-pdp-ddc-intro -->

    <div class="ctpx-details-wrapper" :class="{ 'surprise-me': isSurprise }">
      <div class="ctpx-pdp-details ctpx-pdp-details-ddc">
        <div class="row g-0">
          <div
            class="col-sm-12 col-lg-5 order-lg-2 d-flex justify-content-center justify-content-lg-end"
          >
            <!-- ==================== Del Dia Box Toggler ==================== -->
            <div
              v-if="choiceProducts.length > 0"
              class="del-dia-box-toggler"
              :class="{ 'surprise-me': isSurprise }"
              @click="toggleSurpriseMe()"
            >
              <div class="choose display-6">I'll Choose</div>
              <!-- .choose -->
              <div class="toggle"><span class="dot"></span></div>
              <!-- .toggle -->
              <div class="surprise display-6">Surprise Me</div>
              <!-- .surprise -->
            </div>
            <!-- del-dia-box-toggler -->
          </div>
          <!--.col-->
          <div
            class="col-12 col-md-auto col-lg-6 order-lg-1 justify-content-sm-center justify-content-md-start"
          >
            <!-- ==================== Del Dia Color Box ==================== -->
            <div class="del-dia-box colors" v-if="!isSurprise" ref="box-title">
              <div
                v-if="choiceProducts.length > 5"
                class="row flex-row-center color-swatches justify-content-sm-center justify-content-md-start"
              >
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.red ||
                        x.color === Colors.brightRed ||
                        x.color === Colors.pink
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-red"
                      name="radioColor"
                      value="red"
                      v-model="filteredColors"
                    />
                    <label for="radio-red"
                      ><span style="background-color: #f52d2d">Red</span></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.orange)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-orange"
                      name="radioColor"
                      value="orange"
                      v-model="filteredColors"
                    />
                    <label for="radio-orange"
                      ><span style="background-color: #ff9018"
                        >Orange</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.yellow ||
                        x.color === Colors.brightYellow
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-yellow"
                      name="radioColor"
                      value="yellow"
                      v-model="filteredColors"
                    />
                    <label for="radio-yellow"
                      ><span style="background-color: #f5c853"
                        >Yellow</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.green ||
                        x.color === Colors.darkGreen ||
                        x.color === Colors.limeGreen
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-green"
                      name="radioColor"
                      value="green"
                      v-model="filteredColors"
                    />
                    <label for="radio-green"
                      ><span style="background-color: #326957"
                        >Green</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.blue ||
                        x.color === Colors.darkBlue ||
                        x.color === Colors.teal ||
                        x.color === Colors.lightBlue
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-blue"
                      name="radioColor"
                      value="blue"
                      v-model="filteredColors"
                    />
                    <label for="radio-blue"
                      ><span style="background-color: #0098db"
                        >Blue</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.purple)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-purple"
                      name="radioColor"
                      value="purple"
                      v-model="filteredColors"
                    />
                    <label for="radio-purple"
                      ><span style="background-color: #7f84c6"
                        >Purple</span
                      ></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div
                  v-if="
                    choiceProducts.some(
                      (x) =>
                        x.color === Colors.black ||
                        x.color === Colors.white ||
                        x.color === Colors.gray
                    )
                  "
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-black"
                      name="radioColor"
                      value="gray"
                      v-model="filteredColors"
                    />
                    <label for="radio-black"
                      ><span style="background-color: gray">Gray</span></label
                    >
                  </div>
                </div>
                <!-- .col -->
                <div
                  v-if="choiceProducts.some((x) => x.color === Colors.brown)"
                  class="col-auto"
                >
                  <div @click="goto('box-title')" class="dd-color-family">
                    <input
                      type="checkbox"
                      id="radio-brown"
                      name="radioColor"
                      value="brown"
                      v-model="filteredColors"
                    />
                    <label for="radio-brown"
                      ><span style="background-color: brown">Brown</span></label
                    >
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
                <div class="col-auto">
                  <div @click="goto('box-title')" class="dd-color-family all">
                    <button @click="clearColorFilters()" class="btn btn-black">
                      View All
                    </button>
                  </div>
                  <!-- .dd-color-family -->
                </div>
                <!-- .col -->
              </div>
              <!-- .row  -->
            </div>
          </div>
          <!--.col-->
          <!-- del-dia-box -->
          <div class="col-12 col-md col-lg-1 order-lg-3 justify-content-lg-end">
            <!-- ==================== Del Dia Refresh Button ==================== -->
            <div class="del-dia-box favorites" v-if="!isSurprise">
              <img
                @click="refreshGrid(), rotateBtn()"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/refresh.svg"
                loading="lazy"
                alt="refresh grid"
                class="refresh-grid"
                style="width: 30px"
                id="refreshBtn"
              />
              <img
                v-if="!showFullHeart"
                @click="filterFavorites(), (showFullHeart = !showFullHeart)"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav.svg"
                loading="lazy"
                alt="favorite icon"
                class="favorite"
                style="width: 30px"
              />
              <img
                v-else
                @click="filterFavorites(), (showFullHeart = !showFullHeart)"
                src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav-full.svg"
                loading="lazy"
                alt="favorite icon"
                class="favorite"
                style="width: 30px"
              />
            </div>
            <!-- del-dia-box -->
          </div>
          <!--.col-->
        </div>
        <!--.row-->
        <!-- ==================== Del Dia Choose Box ==================== -->
        <div
          class="del-dia-box col choose"
          v-if="!isSurprise"
          id="anchor-choice"
        >
          <delDiaSlide
            :product="selectedVariant"
            :abVersion="abVersion"
            :productId="productId"
            :accordionContent="accordionContent"
            :lifestyleImgs="lifestyleImgs"
          ></delDiaSlide>
          <div class="row">
            <div class="col">
              <div class="dd-choices ddc">
                <div class="dd-choices-grid">
                  <div class="row flex-row">
                    <div
                      v-if="filteredChoices.length == 0"
                      class="col text-center"
                    >
                      <h4>
                        You haven't selected any favorites yet.
                        <a @click="clearColorFilters()" class="btn btn-link"
                          >Start Favoriting!</a
                        >
                      </h4>
                    </div>
                  </div>
                  <!--.row-->
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3 choice-grid-item"
                      v-for="product in filteredChoices.slice(0, 48)"
                      :key="product.src"
                    >
                      <img
                        v-if="!product.favorite"
                        @click="toggleFavorite(product)"
                        src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav.svg"
                        loading="lazy"
                        alt="favorite icon"
                        class="favorite"
                      />
                      <img
                        v-else
                        @click="toggleFavorite(product)"
                        src="https://cdn.shopify.com/s/files/1/0281/7544/files/fav-full.svg"
                        loading="lazy"
                        alt="favorite icon"
                        class="favorite"
                      />
                      <div
                        @click="selectVariant(product), openSlide()"
                        class="dd-choice-image"
                        :class="{ active: selectedVariant === product }"
                      >
                        <img
                          :src="
                            product.images[0].src.replace('w_1024', 'w_350')
                          "
                          :srcset="
                            product.images[0].src.replace('w_1024', 'w_700') +
                            ' 2x'
                          "
                          itemprop="image"
                          width="350"
                          height="350"
                        />
                        <img
                          :src="
                            product.images[1].src.replace('w_1024', 'w_350')
                          "
                          :srcset="
                            product.images[1].src.replace('w_1024', 'w_700') +
                            ' 2x'
                          "
                          itemprop="image"
                          class="hoverShow"
                          width="350"
                          height="350"
                        />
                        <span v-if="product.viewed" class="viewed-tag display-6"
                          >Viewed</span
                        >
                      </div>
                      <!-- .dd-choice-image -->
                    </div>
                  </div>
                  <!-- .row -->
                </div>
                <!-- .dd-choices-grid -->
              </div>
              <!-- .dd-choices -->
            </div>
            <!-- col -->
          </div>
          <!-- .row -->
        </div>
        <!-- del-dia-box -->

        <div
          class="del-dia-box surprise"
          v-if="isSurprise"
          id="anchor-surprise"
        >
          <div class="row flex-row-center">
            <div class="col-md-6">
              <div class="row">
                <div class="col-xl-11 offset-xl-1">
                  <div class="ctpx-carousel">
                    <swiper
                      :modules="modules"
                      :slides-per-view="1"
                      :space-between="50"
                      :lazy="true"
                      :zoom="true"
                      navigation
                      @swiper="onSwiper"
                      @slideChange="onSlideChange"
                    >
                      <swiper-slide v-for="(img, index) in ddProduct.images">
                        <div class="swiper-zoom-container">
                          <img
                            :src="
                              img.src.includes('png')
                                ? img.src.replace('.png', '_550x.png')
                                : img.src.includes(jpg)
                                ? img.src.replace('.jpg', '_550x.jpg')
                                : img.src
                            "
                            :srcset="
                              img.src.includes('png')
                                ? img.src.replace('.png', '_1100x.png')
                                : img.src.includes(jpg)
                                ? img.src.replace('.jpg', '_1100x.jpg')
                                : img.src + ' 2x'
                            "
                            :alt="img.alt"
                            class="img-fluid swiper-lazy"
                            draggable="false"
                            width="700"
                            height="700"
                          />
                          <span v-if="index == 0" class="small-print"
                            >*Images are representative, colors will vary</span
                          >
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                  <!-- ctpx-carousel -->
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .col -->
            <div class="col-md-6">
              <div class="row">
                <div class="col-xl-10 offset-xl-2">
                  <div class="dd-bag-details">
                    <!-- ==================== Detail Box ==================== -->
                    <div class="detail-box">
                      <div class="row">
                        <div class="col">
                          <h1>Surprise Pack</h1>
                          <h4 class="price display-5">
                            <span v-if="isSurprise">{{
                              filterPrice(ddProduct.price)
                            }}</span>
                          </h4>
                        </div>
                        <!-- .col -->
                      </div>
                      <!-- .row -->
                      <div class="row">
                        <div class="col">
                          <p>
                            Each pack in this collection is one-of-a-kind. We’ll
                            choose a pack for you at random. Be prepared for a
                            total surprise!
                          </p>
                        </div>
                        <!-- .col -->
                      </div>
                      <!-- .row -->
                    </div>
                    <!-- detail-box -->
                    <!-- ==================== Add to Cart Box (Surprise) ==================== -->
                    <div v-if="soldout" class="add-to-cart-box sold-out">
                      <button class="btn btn-black">Sold Out</button>
                    </div>
                    <!-- .add-to-cart-box -->
                    <div v-else class="add-to-cart-box">
                      <button
                        id="AddToCart"
                        class="btn btn-black"
                        @click="addToCart"
                      >
                        Add to Cart -
                        <span class="price">{{
                          filterPrice(ddProduct.price)
                        }}</span>
                      </button>
                    </div>
                    <!-- .add-to-cart-box -->

                    <!-- ========== Bundler Box ========== -->
                    <div
                      v-if="uptContentWell"
                      class="bundler-box"
                      :class="{ dark: uptContentWell.textColor === 'dark' }"
                      :style="{
                        backgroundColor: uptContentWell.backgroundColor,
                      }"
                    >
                      <h4>{{ uptContentWell.title }}</h4>
                      <p>{{ uptContentWell.subtitle }}</p>
                      <a
                        v-if="uptContentWell.ctaTitle && uptHandle"
                        :href="'/collections/' + uptHandle"
                        class="btn btn-black btn-block"
                        >{{ uptContentWell.ctaTitle }}</a
                      >
                      <hr />
                      <p>
                        <small>{{ uptContentWell.disclaimerText }}</small>
                      </p>
                    </div>
                    <!-- .bundler-box -->

                    <!-- ==================== GFG Box ==================== -->
                    <a
                      href="/pages/guaranteed-for-good"
                      alt="Guaranteed for Good™"
                      target="_blank"
                      class="guaranteed-for-good-box d-flex flex-column align-items-center"
                    >
                      <h3 class="text-center" style="margin-bottom: 20px">
                        Guaranteed for Good™
                      </h3>
                      <div class="row icon-row flex-nowrap mx-2">
                        <div class="col-4 flex-column text-center">
                          <img
                            class="img-icon"
                            src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Free-Returns-Exchanges.svg"
                            loading="lazy"
                            width="30px"
                            height="30px"
                          />
                          <span class="text-center"
                            >Easy Returns and Exchanges</span
                          >
                        </div>
                        <!-- .col-4 -->
                        <div class="col-4 flex-column text-center">
                          <img
                            class="img-icon"
                            src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Lifetime-Warranty.svg"
                            loading="lazy"
                            width="30px"
                            height="30px"
                          />
                          <span class="text-center"
                            >Lifetime Warranty + Repairs</span
                          >
                        </div>
                        <!-- .col-4 -->
                        <div class="col-4 flex-column text-center">
                          <img
                            class="img-icon"
                            src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-RePurposed.svg"
                            loading="lazy"
                            width="30px"
                            height="30px"
                          />
                          <span class="text-center"
                            >Trade-In for Gift Cards</span
                          >
                        </div>
                        <!-- .col-4 -->
                      </div>
                      <!-- .row --> 
                      </a><!-- guaranteed-for-good-box -->
                  </div>
                  <!-- .dd-bag-details -->
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- del-dia-box -->
      </div>
      <!-- ctpx-pdp-details -->
    </div>
    <!-- ctpx-details-wrapper -->

    <div class="ctpx-pdp-images ctpx-pdp-images-ddc" id="ddpdpImagesC">
      <div class="row" id="anchor-features">
        <div class="col text-center">
          <h1>Product Features</h1>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <div class="row mobile-hidden image-grid-row"  v-if="!isMobile">
        <div
          class="col-sm-6 img-mapper-container"
          v-for="(img, i) in pinContent"
          :key="img.src"
        >
          <div class="img-mapper">
            <img
              :src="img.image.replace('upload', 'upload/w_700/f_auto,q_auto')"
              :srcset="img.image.replace('upload', 'upload/w_1100/f_auto,q_auto') + ' 2x'"
              alt="details"
              class="img-fluid lazy-load"
              width="700"
              height="700"
            />
            <div
              v-for="(pin, ii) in img.pins.filter((x) => x.description)"
              class="map-pin"
              :style="'top:' + pin.yPosition + '%;left:' + pin.xPosition + '%;'"
              :class="{ active: activePin === i + '' + ii }"
            >
              <a class="pin-point" @click="activatePin(i + '' + ii)">+</a>
              <span class="pin-content">{{ pin.description }}</span>
            </div>
            <!-- .map-pin -->
          </div>
          <!-- .img-mapper -->
        </div>
        <!-- .col-sm-6 -->
        <div class="col-sm-6 img-mapper-container" v-if="!ddProduct.imageMaps">
          <div class="img-mapper">
            <img
              :src="
                ddProduct.images[0].src.includes('png')
                  ? ddProduct.images[0].src.replace('.png', '_700x.png')
                  : ddProduct.images[0].src.includes(jpg)
                  ? ddProduct.images[0].src.replace('.jpg', '_700x.jpg')
                  : ddProduct.images[0].src
              "
              :srcset="
                ddProduct.images[0].src.includes('png')
                  ? ddProduct.images[0].src.replace('.png', '_1100x.png')
                  : ddProduct.images[0].src.includes(jpg)
                  ? ddProduct.images[0].src.replace('.jpg', '_1100x.jpg')
                  : ddProduct.images[0].src + ' 2x'
              "
              :alt="ddProduct.images[0].alt"
              class="img-fluid lazy-load"
              width="700"
              height="700"
            />
          </div>
          <!-- .img-mapper -->
        </div>
        <!-- .col-sm-6 -->
        <div class="col-sm-6 accordion-slide">
          <!-- ==================== accordion-box ==================== -->
          <div class="accordion-box">
            <div
              class="accordion-item"
              v-for="(accordion, index) in accordionContent"
              :class="{ active: activeDrawer === index }"
              :key="accordion.title"
            >
              <div class="accordion-header" @click="activateAccordion(index)">
                <h4>{{ accordion.title }}</h4>
              </div>
              <!-- accordion-header -->
              <div class="accordion-content">
                <div v-html="accordion.content"></div>
              </div>
              <!-- accordion-content -->
            </div>
            <!-- .accordion-item -->
          </div>
          <!-- .accordion-box -->
        </div>
        <!-- .col-sm-6 -->
      </div>
      <!-- .row -->

      <div class="row ctpx-carousel image-grid-row"  v-else>
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="50"
          :lazy="true"
          :zoom="true"
          navigation
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            class="ctpx-slide img-mapper-container"
            v-for="(img, index) in pinContent"
            :id="'img2' + index"
            :key="img.image"
          >
            <div class="img-mapper">
              <div class="swiper-zoom-container">
                <img
                  :src="img.image.replace('upload', 'upload/w_700/f_auto,q_auto')"
                  :srcset="img.image.replace('upload', 'upload/w_1100/f_auto,q_auto') + ' 2x'"
                  alt="details"
                  class="img-fluid lazy-load"
                  draggable="false"
                />
                <div
                  v-for="(pin, ii) in img.pins.filter((x) => x.description)"
                  class="map-pin"
                  :style="
                    'top:' + pin.yPosition + '%;left:' + pin.xPosition + '%;'
                  "
                  :class="{ active: activePin === index + '' + ii }"
                >
                  <a class="pin-point" @click="activatePin(index + '' + ii)"
                    >+</a
                  >
                  <span class="pin-content">{{ pin.description }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide
            v-if="!ddProduct.imageMaps"
            class="ctpx-slide"
            v-for="(img, index) in ddProduct.images"
            :id="'img2' + index"
            :key="img.src"
          >
            <img
              :src="
                img.src.includes('png')
                  ? img.src.replace('.png', '_750x.png')
                  : img.src.includes(jpg)
                  ? img.src.replace('.jpg', '_750x.jpg')
                  : img.src
              "
              :srcset="
                img.src.includes('png')
                  ? img.src.replace('.png', '_1100x.png')
                  : img.src.includes(jpg)
                  ? img.src.replace('.jpg', '_1100x.jpg')
                  : img.src + ' 2x'
              "
              :alt="img.alt"
              class="img-fluid swiper-lazy"
              draggable="false"
              width="700"
              height="700"
            />
          </swiper-slide>
        </swiper>
      </div>
      <!-- ctpx-carousel -->

      <!-- ==================== accordion-box ==================== -->
      <div class="row accordion-box mobile-only" v-if="isMobile">
        <div
          class="accordion-item"
          v-for="(accordion, index) in accordionContent"
          :class="{ active: activeDrawer === index }"
          :key="accordion.title"
        >
          <div class="accordion-header" @click="activateAccordion(index)">
            <h4>{{ accordion.title }}</h4>
          </div>
          <!-- accordion-header -->
          <div class="accordion-content">
            <div v-html="accordion.content"></div>
          </div>
          <!-- accordion-content -->
        </div>
        <!-- .accordion-item -->
      </div>
      <!-- .accordion-box -->
    </div>
    <!-- .ctpx-pdp-images -->
  </div>
  <!-- pdpDdaba -->
</template>

<script src="./ctrl-pdp-del-dia.js"></script>
